import styled from 'styled-components';
import { Container } from '../mediaQuery';

export const CardContainer = styled(Container)`
    background-color:lightgreen;
    height: 450px;
    padding: 0;
    margin: 100px auto;

`;
